module.exports = __webpack_public_path__ + "static/media/alertIcon.b94ac419.svg";